import React, { useState ,useEffect} from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useLocation } from 'react-router-dom';

const PopupInfo = () => {
  const queryParams = new URLSearchParams(window.location.search);
  //const passedTable = queryParams.get('table') || '';
  const passedTable = queryParams.get('table');
  const isValidTable = passedTable && passedTable.trim() !== '';
  const [showPopup, setShowPopup] = useState(isValidTable);
  
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    orderType: 'dine-in',
    tableNo: passedTable
  });



  useEffect(() => {
    if (isValidTable) {
      setFormData(prev => ({ ...prev, tableNo: passedTable }));
      setShowPopup(true);
    }
    
  }, [isValidTable, passedTable]);

  useEffect(() => {
    const hasTableParam = new URLSearchParams(window.location.search).get('table');
    if (!hasTableParam) {
      localStorage.removeItem('customerInfo');
    }
  }, []);
  
  
  const handleChange = (e) => {
    const { id, value, name, type } = e.target;
    const field = type === 'radio' ? name : id;
    setFormData((prev) => ({
      ...prev,
      [field]: value,
      ...(field === 'orderType' && value === 'pickup' ? { tableNo: '' } : {})
    }));
  };
  const submitInfo = async () => {
    const { name, mobile, orderType, tableNo } = formData;
    if (!showPopup || !tableNo.trim()) return;
  
  
    if (!name.trim() || !mobile.trim()) {
      toast.error('Please fill in all required details');
      return;
    }
  
    localStorage.setItem(
      'customerInfo',
      JSON.stringify({ name, mobile, tableNo })
    );
  
    try {
      const res = await fetch('http://localhost:4000/api/infoRoute/save-info', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name, mobile, orderType, tableNo }),
      });
  
      const data = await res.json();
      if (res.ok) {
        toast.success('Thank you!');
        setTimeout(() => {
          setShowPopup(false);
        }, 1000);
      } else {
        toast.error('Error: ' + data.error);
      }
    } catch (error) {
      toast.error('Error: ' + error.message);
    }
  };
  
  return showPopup ? (
    <div style={overlayStyle}>
      <div style={popupStyle}>
        <ToastContainer position="top-center" autoClose={3000} />
        <h3 style={headerStyle}>Enter Your Details</h3>
  
        <input
          type="text"
          id="name"
          placeholder="Full Name"
          value={formData.name}
          onChange={handleChange}
          style={inputStyle}
        />
        <input
          type="text"
          id="mobile"
          placeholder="Mobile Number"
          value={formData.mobile}
          onChange={handleChange}
          style={inputStyle}
        />
  
        <div style={radioGroupStyle}>
          <label style={radioLabelStyle}>
            <input
              type="radio"
              name="orderType"
              value="dine-in"
              checked={formData.orderType === 'dine-in'}
              onChange={handleChange}
              style={radioInputStyle}
            />
            Dine In
          </label>
          <label style={radioLabelStyle}>
            <input
              type="radio"
              name="orderType"
              value="pickup"
              checked={formData.orderType === 'pickup'}
              onChange={handleChange}
              style={radioInputStyle}
            />
            Pickup
          </label>
          <label style={radioLabelStyle}>
            <input
              type="radio"
              name="orderType"
              value="delivery"
              checked={formData.orderType === 'delivery'}
              onChange={handleChange}
              style={radioInputStyle}
            />
            Delivery
          </label>
        </div>
  
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
  <label style={{ marginRight: '10px', fontSize: '16px', color: '#555' }}>Table No</label>
  <input
    type="text"
    value={formData.tableNo}
    readOnly
    style={{ ...inputStyle, margin: 0, width: '150px' }} 
  />
</div>
        <button onClick={submitInfo} style={submitButtonStyle}>
          Submit
        </button>
      </div>
    </div>
  ) : null;
  
  
};

const popupStyle = {
  display: 'block',
  position: 'fixed',
  
  width:'400px',
  backgroundColor: 'white', 
  padding: '20px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  boxShadow: '0 0 20px rgba(0,0,0,0.3)',
  zIndex: 1000,
  textAlign: 'center'
};

const headerStyle = {
  fontSize: '24px',
  marginBottom: '20px',
  color: '#333',
  fontFamily: 'Arial, sans-serif',
};

const inputStyle = {
  display: 'block',
  margin: '12px auto',
  width: '80%',
  padding: '12px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '16px',
  transition: 'border 0.3s ease',
};
const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.5)', 
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 999
};

const radioGroupStyle = {
  display: 'block',
  justifyContent: 'left',
  marginright: '10px auto',
  marginBottom:'20px'
};

const radioLabelStyle = {
  margin: '0 15px',
  fontSize: '16px',
  color: '#555',
};

const radioInputStyle = {
  marginRight: '8px',
};

const submitButtonStyle = {
  backgroundColor: '#28a745',
  color: 'white',
  padding: '12px 30px',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  fontSize: '16px',
  transition: 'background-color 0.3s ease',
};

submitButtonStyle[':hover'] = {
  backgroundColor: '#218838',
};

export default PopupInfo;
